(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var header = document.querySelector('[data-header-overlay]');
    if (header) {
      var threshold = 20;
      function onScroll() {
        header.classList.toggle('is-scrolled', window.scrollY > threshold);
      }
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }

    var megamenuNavs = document.querySelectorAll('[data-nav-megamenu]');
    if (!megamenuNavs.length) return;

    var closeTimer;
    var activeNav = null;
    var activePanel = null;
    var activeBtn = null;

    function syncMegamenuPosition(panel) {
      var bar = document.querySelector('.ejuno-header .header-bar');
      if (!bar || !panel) return;
      var top = Math.round(bar.getBoundingClientRect().bottom);
      document.documentElement.style.setProperty('--ejuno-megamenu-top', top + 'px');
      panel.style.top = top + 'px';
    }

    function closeActiveMenu() {
      if (!activePanel || !activeBtn || !activeNav) return;
      activePanel.hidden = true;
      activeBtn.setAttribute('aria-expanded', 'false');
      activeNav.classList.remove('is-open');
      activeNav = null;
      activePanel = null;
      activeBtn = null;
      document.body.classList.remove('ejuno-megamenu-open');
    }

    function openMenu(nav, btn, panel) {
      clearTimeout(closeTimer);
      if (typeof window.ejunoCloseHeaderAccountMenus === 'function') {
        window.ejunoCloseHeaderAccountMenus();
      }
      if (activePanel && activePanel !== panel) closeActiveMenu();
      panel.hidden = false;
      syncMegamenuPosition(panel);
      btn.setAttribute('aria-expanded', 'true');
      nav.classList.add('is-open');
      activeNav = nav;
      activePanel = panel;
      activeBtn = btn;
      document.body.classList.add('ejuno-megamenu-open');
    }

    function scheduleClose() {
      closeTimer = setTimeout(closeActiveMenu, 260);
    }

    window.addEventListener(
      'scroll',
      function () {
        if (activePanel) syncMegamenuPosition(activePanel);
      },
      { passive: true }
    );
    window.addEventListener('resize', function () {
      if (activePanel) syncMegamenuPosition(activePanel);
    });

    megamenuNavs.forEach(function (nav) {
      var btn = nav.querySelector('.nav-megamenu-trigger');
      var panelId = btn && btn.getAttribute('aria-controls');
      var panel = panelId && document.getElementById(panelId);
      if (!btn || !panel) return;

      nav.addEventListener('mouseenter', function () {
        openMenu(nav, btn, panel);
      });
      nav.addEventListener('mouseleave', scheduleClose);
      panel.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        openMenu(nav, btn, panel);
      });
      panel.addEventListener('mouseleave', scheduleClose);
      btn.addEventListener('focus', function () {
        openMenu(nav, btn, panel);
      });
      /* Click navigates to the tab landing page; hover/focus opens the dropdown */
      btn.addEventListener('click', function () {
        closeActiveMenu();
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeActiveMenu();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
